// removed by extract-text-webpack-plugin
module.exports = {"popover":"_1hUij","popoverBody":"_1tg0R","popoverBodyLeft":"_1RkU2","popoverBodyRight":"_2XtHo"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Popover/index.sass
// module id = 815
// module chunks = 0 1